import React from 'react';
import { Dac7Data } from '../../../../../../typings/dac7';
import S from '../style/Dac7TabContent';
import Dac7IbanField from './Dac7IbanField';
import Dac7Input from './Dac7Input';
import V from '../utils/validation';
import { useI18n } from '../../../../../i18n';

interface Props {
  financialDetails: Dac7Data['data']['financialDetails'];
  frozenFinancialDetails: Dac7Data['frozenData']['financialDetails'];
}
const Dac7FinancialDetails = ({ financialDetails, frozenFinancialDetails }: Props) => {
  const i18n = useI18n();

  return (
    <>
      <S.Dac7Fieldset className="dac7-financial-details">
        <S.Dac7FormField>
          <Dac7IbanField
            name="dac7_financialDetails.iban"
            label={i18n('dlv_dac7_iban')}
            value={financialDetails?.iban || ''}
            required
            disabled={!!frozenFinancialDetails?.iban}
          />
        </S.Dac7FormField>
        <S.Dac7FormField>
          <Dac7Input
            name="dac7_financialDetails.holderName"
            label={i18n('dlv_dac7_accountHolderName')}
            pattern={V.HOLDER_NAME_PATTERN}
            required
            value={financialDetails?.holderName}
            disabled={!!frozenFinancialDetails?.holderName}
          />
        </S.Dac7FormField>
      </S.Dac7Fieldset>
      <S.StyledRequiredFieldsText>
        {i18n(`dlv_dac7_required_fields_description`)}
      </S.StyledRequiredFieldsText>
    </>
  );
};

export default Dac7FinancialDetails;
